import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SetupCaptureEmailPage } from './setup-capture-email.page';
import { CaptureEmailFormModule } from 'src/app/components/capture-email-form/capture-email-form.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([{path: '', component: SetupCaptureEmailPage}]),
    TranslateModule,
    CaptureEmailFormModule
  ],
  declarations: [SetupCaptureEmailPage]
})

export class SetupCaptureEmailModule {}
